<template>
    <user-team-card
        :lead="props.lead"
        :user="props.lead.referrer.user"
        :team="props.lead.referrer.team"
        :assignable-users="assignableReferrerUsersCollection"
        :editable="canChangeReferrer"
        @user-change="changeReferrer($event)"
    >
        <template #title>
            Aanmaker
        </template>
    </user-team-card>
</template>

<script lang="ts" setup>
    import useClient from '@composables/useClient';
    import useLeadSecurity from '@composables/security/useLeadSecurity';
    import { computed } from 'vue';
    import useNotify from '@composables/useNotify';
    import useEventBus from '@composables/useEventBus';
    import { Lead, User } from '@keyvue/one-api-client';
    import { ReferralAPI, UserAPI } from '@keyvue/one-api-client-legacy';
    import UserTeamCard from '@components/Cards/UserTeamCard.vue';

    interface Props {
        lead: Lead;
    }

    const props = defineProps<Props>();
    const { client, currentLegacyUser, currentLegacyCompany } = useClient();
    const { canChangeReferrer } = await useLeadSecurity(props.lead);
    const { notifySaving, notifySaved } = useNotify();
    const eventBus = useEventBus();

    const [
        assignableReferrerUserCollection,
    ] = await Promise.all([
        await client.getSubResources(props.lead.referrer.team, User, 'available-users'),
    ]);

    const assignableReferrerUsersCollection = computed(() => assignableReferrerUserCollection.data);

    const changeReferrer = async (user: User) => {
        const closeNotification = notifySaving(undefined, 0);

        const legacyUser = await UserAPI.get(user.id.value);
        await ReferralAPI.updateReferredBy(
            currentLegacyCompany.value,
            props.lead.id.value,
            legacyUser,
            currentLegacyUser.value,
        );

        notifySaved();
        if (closeNotification) {
            closeNotification();
        }

        eventBus.dispatch('resource-manipulated', 'Lead');
    };
</script>
